import axios from "axios";
import jstat from "jstat";
import Highcharts from 'highcharts';


Highcharts.setOptions({
	colors: [
		//prev adv_prev, low_prev, w_prev
		'#7cb5ec', '#434348', '#90ed7d', '#f7a35c', 
		'#12406d', '#cacaca', '#21880c', '#aa5309', 
		'#91e8e1']
});

const apiUrls = {
	selectOptions: `${process.env && process.env.REACT_APP_API_URL ?  
		process.env.REACT_APP_API_URL 
		: ''
	}/data/summary`,
	dataValues: `${process.env && process.env.REACT_APP_API_URL ?  
		process.env.REACT_APP_API_URL 
		: ''
	}/data/raw`,
	dataValuesGraphing: `${process.env && process.env.REACT_APP_API_URL ?  
		process.env.REACT_APP_API_URL 
		: ''
	}/data/graph`,
	dataDownloadCsv:  `${process.env && process.env.REACT_APP_API_URL ?  
		process.env.REACT_APP_API_URL 
		: ''
	}/data/csv`,
	
	stateSpeciesPathoData:  `${process.env && process.env.REACT_APP_API_URL ?  
		process.env.REACT_APP_API_URL 
		: ''
	}/data/state`
};


export const DownloadDataIntoCsv = (dataOptions, iframeRef) => {
	
	const joinArr = [];
	if(dataOptions.state){
		joinArr.push(dataOptions.state)
		if(dataOptions.region){
			joinArr.push(dataOptions.region)
			if(dataOptions.subregion){
				joinArr.push(dataOptions.subregion)
				if(dataOptions.sitecode){
					joinArr.push(dataOptions.sitecode)
				}
			}
		}
	}
	//const additionalParams = [];
	const additionalParams = [];
	if(dataOptions.disease) {
		additionalParams.push(`disease=${dataOptions.disease}`);
	}
	if(dataOptions.species) {
		additionalParams.push(`species=${dataOptions.species}`);
	}
	
	iframeRef.current.src = `${apiUrls.dataDownloadCsv}/${joinArr.join('/')}${(additionalParams.length > 0 ? 
		'?' + additionalParams.join('&') 
		: '')}`;


}













const monthItems = {
	'1':'Jan',
	'2':'Feb',
	'3':'Mar',
	'4':'Apr',
	'5':'May',
	'6':'Jun',
	'7':'Jul',
	'8':'Aug',
	'9':'Sep',
	'10':'Oct',
	'11':'Nov',
	'12':'Dec'
};

export const GetGraphingOptions = () => {
	return axios.get(
		apiUrls.selectOptions,
		{}
	);
}


export const GetGraphingData = (dataOptions) => {
	const joinArr = [];
	if(dataOptions.state){
		joinArr.push(dataOptions.state)
		if(dataOptions.region){
			joinArr.push(dataOptions.region)
			if(dataOptions.subregion){
				joinArr.push(dataOptions.subregion)
				if(dataOptions.sitecode){
					joinArr.push(dataOptions.sitecode)
				}
			}
		}
	}
	//const additionalParams = [];
	const additionalParams_static = {};
	if(dataOptions.disease) {
		//additionalParams.push(`disease=${dataOptions.disease}`);
		additionalParams_static.disease = dataOptions.disease;
	}
	if(dataOptions.species) {
		//additionalParams.push(`species=${dataOptions.species}`);
		additionalParams_static.species = dataOptions.species;
	}
	if(dataOptions.chartOptions) {
		additionalParams_static.chartOptions = dataOptions.chartOptions;
	}


	return axios.get(
		`${apiUrls.dataValues}/${joinArr.join('/')}`,
		{params: additionalParams_static}
	);
}



//This function will obviously need to be re-written to better deal with things
export const CompileDataIntoHighcharts = ({filters, data}) => {

	const highchartsOptions = {
		chart: { type: (filters.chartOptions && filters.chartOptions.type ?  filters.chartOptions.type : 'line') },
		legend:{
			enabled:true,
			
			//align: 'right',
			//verticalAlign: 'top',
		},
		title: {
		  text: 'N/A'// concatTitle.join(' - ')
		},
		
		yAxis: {
			title: {
				text: 'Prevalence Values'
			}
		},
	
		xAxis: {
			title: {
				text: 'Year'
			}
		},
		plotOptions: {
			series: {
				label: {
					enabled:false,
					connectorAllowed: false
				}
			}
		}
		,tooltip: {}
		,exporting: {
		  buttons: {
			contextButton: {
			  menuItems: ["printChart",
						  "separator",
						  "downloadPNG",
						  "downloadJPEG",
						  "downloadPDF",
						  "downloadSVG",
						  "separator",
						  "downloadCSV",
						  "downloadXLS",
						  //"viewData",
						  //"openInCloud"
			  ]
			}
		  }
		},
	
		series: null
	};



	const chartOptions = filters.chartOptions || {
		type: 'line',
		dataset: 'prevalence',
		year: null
	};

	//console.log('Using chart options: ', chartOptions);

	const seriesData = _CompileSeriesData(data, chartOptions.type, chartOptions.dataset, chartOptions.year);

	highchartsOptions.series=seriesData;//_Highcharts_LineChartByYear(data);

	//console.log('COMPILED DATA: ', seriesData);

	//Finish title and tooltips.
	//Title

	const concatTitle = [];
	const concatSubtitle = [];
	let subtitleYear ='';
	if(filters.state){
		concatTitle.push(filters.state)
		if(filters.region){
			concatTitle.push(filters.region)
			if(filters.subregion){
				concatTitle.push(filters.subregion)
				if(filters.sitecode){
					concatTitle.push(filters.sitecode)
				}
			}
		}
	}

	if( filters.species ) {
		concatSubtitle.push(`${filters.species}`);
	}else{
		concatSubtitle.push(`All Available Species`);
	}
	if( filters.disease ) {
		concatSubtitle.push(`${filters.disease}: Live Values`);
	}else{
		concatSubtitle.push(`All Available Pathogens: Live Values`);
	}
	


	//Tooltip
	if( chartOptions.type === 'line' ) {
		//Do not use arrow function here right now. Can refactor it later
		highchartsOptions.tooltip.shared=true;
		highchartsOptions.tooltip.formatter = function (_argA, _argB) {
			//console.log('Tooltip formatter', {this: this, argA, argB});

			var s = '<b>' + this.x + '</b>';
			let mySampleTotal = 'N/A';
            this.points.forEach( (pointData) => {
				if( pointData.series.name==='Range' ) {
					s += '<br/>' + pointData.series.name + ': ' +
						Highcharts.numberFormat(pointData.point.low, 3) 
						+' - ' 
						+ Highcharts.numberFormat(pointData.point.high, 3)  ;
				}else{
					//console.log('My Point Data: ', pointData);
					s += '<br/>' + pointData.series.name + ': ' +
						Highcharts.numberFormat(pointData.y, 3)  ;
					mySampleTotal = pointData.series.options.sampleTotal[pointData.point.index];
				}
			});

			s += '<br/> Total Number of Samples: ' + mySampleTotal;
            return s;
		}

		if( chartOptions.dataset === 'weighted-prevalence' ) {
			highchartsOptions.yAxis.min=0
			highchartsOptions.yAxis.max=5;
			highchartsOptions.yAxis.tickAmount=6;
		}else{
			highchartsOptions.yAxis.min=0
			highchartsOptions.yAxis.max=1;
		}
	}else if( chartOptions.type === 'boxplot' ) {
		subtitleYear = ' (Overall Available Years)';
		if( chartOptions.year !== 'all') {
			subtitleYear = ` (Year of ${chartOptions.year})`;
		}
		highchartsOptions.xAxis = {
			categories: ['Jan', 'Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
		};
		highchartsOptions.yAxis = {
			title: {
				text: 'Prevalence Values'
			},
			floor:0,
			ceiling:5,
		};
		//Do not use arrow function here right now. Can refactor it later
		highchartsOptions.tooltip.formatter = function (_argA) {
			//console.log('Tooltip formatter', {this: this, _argA});

			let seriesName = this.series.name;
			let seriesColor = this.series.color;
			
			let myLow = Highcharts.numberFormat(this.point.low, 3);
			let myQ1 = Highcharts.numberFormat(this.point.q1, 3);
			let myMed = Highcharts.numberFormat(this.point.median, 3);
			let myQ3 = Highcharts.numberFormat(this.point.q3, 3);
			let myHigh = Highcharts.numberFormat(this.point.high, 3);
			//console.log(this.high);
			return '<span style="color:'+seriesColor+'">●</span> <b> '+ seriesName
				+'</b><br/>Maximum: '+myHigh
				+'<br/>Upper quartile: '+myQ3
				+'<br/>Median: '+myMed
				+'<br/>Lower quartile: '+myQ1
				+'<br/>Minimum: '+myLow
				+'<br/>Total Monthly Sample Count: '+ Highcharts.numberFormat(this.point.sampleTotal,0,null,',')
				+'<br/>';
		}

	}else if( chartOptions.type === 'column' ) {
		subtitleYear = ' (Overall Available Years)';
		if( chartOptions.year !== 'all') {
			subtitleYear = ` (Year of ${chartOptions.year})`;
		}
		highchartsOptions.xAxis = {
			categories: ['Jan', 'Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
		};
		highchartsOptions.yAxis = {
			title: {
				text: 'Prevalence Values'
			},
			floor:0,
			min: 0,
		};
		//Do not use arrow function here right now. Can refactor it later
		highchartsOptions.tooltip.formatter = function (_argA) {
			//console.log('Tooltip formatter', {this: this, _argA});

			let seriesName = this.series.name;
			let seriesColor = this.series.color;
			
			let dataY = Highcharts.numberFormat(this.y, 3);
			//console.log(this.high);
			return '<span style="color:'+seriesColor+'">●</span> '+ seriesName
				+': <b>' + dataY + '</b>'
				+'<br/>'
				+ ' Total Monthly Samples: <b>' + Highcharts.numberFormat(this.point.sampleTotal,0,null,',') + '</b>'
				+'<br/>';
		}
		if( chartOptions.dataset === 'prevalence' ) {
			highchartsOptions.plotOptions.column = {
				connectNulls: true,
				stacking: 'normal'
			};
		}

		if( chartOptions.dataset === 'weighted-prevalence' ) {
			highchartsOptions.yAxis.min=0
			highchartsOptions.yAxis.max=5;
			highchartsOptions.yAxis.tickAmount=6;
		}else{
			highchartsOptions.yAxis.min=0
			highchartsOptions.yAxis.max=1;
		}
	}

	


	highchartsOptions.title={
		text: `${concatTitle.join(' - ')}${ concatTitle.length < 3 ? ' (Overall)' : ''}`
	};
	highchartsOptions.subtitle={
		text: `${concatSubtitle.join(' with ')}${subtitleYear}`
	};


	console.log('Final highcharts option:', highchartsOptions);
	return {filters, chartObject:highchartsOptions};
}


/**
 * 
 * @param {object} rawData - the object of data returned by the api point
 * @param {string} [toType=line] - whether this will be for a line, bar, or box plot.
 * @param {string} [dataset=prevalence] - whether this will be for a line, bar, or box plot.
 * @param {string} [byYear=all] - if toType is specifically line, this will be 'all' for now. we're leaving it open ended but that's the way it is for now.
 * @description compiles data that will be used by one of the _Highcharhts_* functions to create the appropriate option.
 * @returns an object that can be used by the "toType" by the "byDate" for direct inserting into highchartsOptions.series
 */
const _CompileSeriesData = (rawData, toType='line', dataset='prevalence', byYear = 'all') => {
	let seriesData = null;
	let _compiledData = [];
	//console.log({rawData, toType, byDate});

	//First compile the data into the format we need
	if( toType === 'line' ) {
		_compiledData = __CompileYearlyData(rawData);
	}else{
		//byDate === 'month'
		_compiledData = __CompileMonthlyData(rawData, byYear);
	}


	if( toType === 'line' ) {

		seriesData = __CompileSeriesDataForLineChart(_compiledData, dataset);

	}else if( toType === 'boxplot' ) {

		seriesData = __CompileSeriesDataForBoxPlotChart(_compiledData, dataset);

	}else if( toType === 'column' ) {

		seriesData = __CompileSeriesDataForColumnChart(_compiledData, dataset);

	}




	//console.log('[_CompileSeriesData] ',_compiledData);

	return seriesData;

}


/**
 * @param {object} compiledData - an object that has been set up in the format of __compileYearlyData or __compileMonthlyData
 * 
 */
 const __CompileSeriesDataForColumnChart = ( compiledData, dataset='all' ) => {
	console.log('[__CompileSeriesDataForColumnChart]', compiledData);


	if( dataset === 'all' ) {
		return __CompileSeriesDataForColumnChart_all(compiledData);
	}
	if( dataset === 'prevalence' ) {
		return __CompileSeriesDataForColumnChart_prev(compiledData);
	}

	return __CompileSeriesDataForColumnChart_wPrev(compiledData);
}
const __CompileSeriesDataForColumnChart_wPrev = (compiledData) => {
	const seriesData =[
		{
			name:'Weighted Prevalence',
			data:[],
			sampleTotal: null,
			colorIndex:3
			//color: Highcharts.getOptions().colors[2],
		}
	];

	Object.keys(compiledData).forEach( (data_month, _idx) =>{
		seriesData[0].data.push({ 
			x: _idx, 
			y: compiledData[data_month].wPrev.mean,
			sampleTotal: compiledData[data_month].sample_size
		});
	} );


	return seriesData;
}
const __CompileSeriesDataForColumnChart_prev = (compiledData) => {


	const seriesData =[
		{
			name:'Prevalence',
			data:[],
			sampleTotal: null,
			colorIndex:2
		},
		{
			name:'Low Prevalence',
			data:[],
			sampleTotal: null,
			colorIndex:0,
			stack:0,
		},
		{
			name:'Adv. Prevalence',
			data:[],
			sampleTotal: null,
			colorIndex:1,
			stack:0,
		}
	];

	console.log('[DataLogic]', compiledData);
	let containsLowPrev = false;
	let containsAdvPrev = false;

	Object.keys(compiledData).forEach( (data_month, _idx) =>{
		seriesData[0].data.push({ 
			x: _idx, 
			y: compiledData[data_month].prev.mean,
			sampleTotal: compiledData[data_month].sample_size
		});
		seriesData[1].data.push({ 
			x: _idx, 
			y: compiledData[data_month].lowPrev.mean,
			sampleTotal: compiledData[data_month].sample_size
		});
		seriesData[2].data.push({ 
			x: _idx, 
			y: compiledData[data_month].advPrev.mean,
			sampleTotal: compiledData[data_month].sample_size
		});

		if( !containsLowPrev && compiledData[data_month].lowPrev.sum > 0 ){
			containsLowPrev=true;
		}
		if( !containsAdvPrev && compiledData[data_month].advPrev.sum > 0 ){
			containsAdvPrev=true;
		}
	} );

	const returnSeries = [];
	if( containsLowPrev  ) {
		returnSeries.push( seriesData[1] );
	}

	if(  containsAdvPrev ) {
		returnSeries.push( seriesData[2] );
	}

	returnSeries.push( seriesData[0] );
	return returnSeries;
/*
	if( containsLowPrev || containsAdvPrev ) {
		return [
			seriesData[2],
			seriesData[1]
		];
	}


	return [seriesData[0]];
	*/
}

const __CompileSeriesDataForColumnChart_all = (compiledData) => {
	const seriesData =[
		{
			name:'Prevalence',
			data:[],
			sampleTotal: null,
			colorIndex:2
		},
		{
			name:'Adv. Prevalence',
			data:[],
			sampleTotal: null,
			colorIndex:1,
		},
		{
			name:'Weighted Prevalence',
			data:[],
			sampleTotal: null,
			colorIndex:3,
		}
	];

	Object.keys(compiledData).forEach( (data_month, _idx) =>{
		seriesData[0].data.push({ 
			x: _idx, 
			y: compiledData[data_month].prev.mean,
			sampleTotal: compiledData[data_month].sample_size
		});
		seriesData[1].data.push({ 
			x: _idx, 
			y: compiledData[data_month].advPrev.mean,
			sampleTotal: compiledData[data_month].sample_size
		});
		seriesData[2].data.push({ 
			x: _idx, 
			y: compiledData[data_month].wPrev.mean,
			sampleTotal: compiledData[data_month].sample_size
		});
	} );


	return seriesData;
}


/**
 * @param {object} compiledData - an object that has been set up in the format of __compileYearlyData or __compileMonthlyData
 * 
 */
 const __CompileSeriesDataForBoxPlotChart = ( compiledData, _dataset='all' ) => {
	console.log('[__CompileSeriesDataForBoxPlotChart]', compiledData);
	const seriesData =[
		{
			name:'Prevalence',
			data:[],
			colorIndex:2
		},
		{
			name:'Low Prevalence',
			data:[],
			colorIndex:0
		},
		{
			name:'Adv. Prevalence',
			data:[],
			colorIndex:1
		},
		{
			name:'Weighted Prevalence',
			data:[],
			colorIndex:3
		}
	];
	let containsLowPrev = false;
	let containsAdvPrev = false;

	Object.keys(compiledData).forEach( (data_month, _idx) =>{
		seriesData[0].data.push({ 
			x: _idx, 
			low: compiledData[data_month].prev.low, 
			q1: compiledData[data_month].prev.q1, 
			median: compiledData[data_month].prev.median, 
			q3: compiledData[data_month].prev.q3,
			high: compiledData[data_month].prev.high,
			sampleTotal: compiledData[data_month].sample_size,  
		});
		seriesData[1].data.push({ 
			x: _idx, 
			low: compiledData[data_month].lowPrev.low, 
			q1: compiledData[data_month].lowPrev.q1, 
			median: compiledData[data_month].lowPrev.median, 
			q3: compiledData[data_month].lowPrev.q3,
			high: compiledData[data_month].lowPrev.high,
			sampleTotal: compiledData[data_month].sample_size,  
		});

		seriesData[2].data.push({ 
			x: _idx, 
			low: compiledData[data_month].advPrev.low, 
			q1: compiledData[data_month].advPrev.q1, 
			median: compiledData[data_month].advPrev.median, 
			q3: compiledData[data_month].advPrev.q3,
			high: compiledData[data_month].advPrev.high,
			sampleTotal: compiledData[data_month].sample_size,  
		});

		seriesData[3].data.push({ 
			x: _idx, 
			low: compiledData[data_month].wPrev.low, 
			q1: compiledData[data_month].wPrev.q1, 
			median: compiledData[data_month].wPrev.median, 
			q3: compiledData[data_month].wPrev.q3,
			high: compiledData[data_month].wPrev.high,
			sampleTotal: compiledData[data_month].sample_size, 
		});
		
		if( !containsLowPrev && compiledData[data_month].lowPrev.sum > 0 ){
			containsLowPrev=true;
		}
		if( !containsAdvPrev && compiledData[data_month].advPrev.sum > 0 ){
			containsAdvPrev=true;
		}
	} );



	const returnSeries = [];

	if( _dataset === 'prevalence') {
		if( containsLowPrev  ) {
			returnSeries.push( seriesData[1] );
		}

		if(  containsAdvPrev ) {
			returnSeries.push( seriesData[2] );
		}

		returnSeries.push( seriesData[0] );
		return returnSeries;
	}else if( _dataset === 'weighted-prevalence') {
		return [
			seriesData[3]
		];
	}

	return seriesData;
}


/**
 * @param {object} compiledData - an object that has been set up in the format of __compileYearlyData or __compileMonthlyData
 * 
 */
const __CompileSeriesDataForLineChart = ( compiledData, dataset='prevalence' ) => {


	console.log('[__CompileSeriesDataForLineChart]', compiledData)
	;


	const seriesDataNew = {
		prev: {
			name: 'Prevalence',
			sampleTotal:[],
			data: [],
			colorIndex:2,
		},
		lowPrev: {
			name: 'Low Prevalence',
			sampleTotal:[],
			data: [],
			colorIndex:0,
		},
		advPrev: {
			name: 'Adv Prevalence',
			sampleTotal:[],
			data: [],
			colorIndex:1,
		},
		wPrev: {
			name: 'Weighted Prevalence',
			sampleTotal:[],
			data: [],
			colorIndex:3,
		},
		intensity: {
			name: 'Intensity',
			intensityPrevSampleTotal:[],
			data: [],
		}
	}
	let containsLowPrev = false;
	let containsAdvPrev = false;
	
	switch(dataset) {
		case 'prevalence':
		case 'adv-prevalence': {
			Object.keys(compiledData).forEach( (data_year, _idx) =>{

				seriesDataNew.prev.sampleTotal.push(compiledData[data_year].sample_size);
				seriesDataNew.prev.data.push([parseInt(data_year), compiledData[data_year].prev.mean ]);

				if( compiledData[data_year].lowPrev.hasValues ) { 
					containsLowPrev=true;
					seriesDataNew.lowPrev.sampleTotal.push(compiledData[data_year].sample_size);
					seriesDataNew.lowPrev.data.push([parseInt(data_year), compiledData[data_year].lowPrev.mean ]);
				}
				if( compiledData[data_year].advPrev.hasValues ) { 
					containsAdvPrev=true;
					seriesDataNew.advPrev.sampleTotal.push(compiledData[data_year].sample_size);
					seriesDataNew.advPrev.data.push([parseInt(data_year), compiledData[data_year].advPrev.mean ]);
				}
			});
			break;
		} 
		case 'weighted-prevalence': {
			Object.keys(compiledData).forEach( (data_year, _idx) =>{
				seriesDataNew.wPrev.sampleTotal.push(compiledData[data_year].sample_size);
				seriesDataNew.wPrev.data.push([parseInt(data_year), compiledData[data_year].wPrev.avg ]);
			});
			break;
		}
		case 'intensity': {

			break;
		}
		default:break;
	}

	const returnSeries = [];
	if( dataset === 'prevalence') { 
		if( containsLowPrev ) { 
			returnSeries.push( seriesDataNew.lowPrev ) ;
			seriesDataNew.prev.dashStyle = 'ShortDashDot';
		}
		if( containsAdvPrev ) { 
			returnSeries.push( seriesDataNew.advPrev ) ;
			seriesDataNew.prev.dashStyle = 'ShortDashDot';
		}
		returnSeries.push( seriesDataNew.prev ) ;
		return returnSeries;
	}else if( dataset === 'adv-prevalence') { 
		if( containsAdvPrev ) { 
			returnSeries.push( seriesDataNew.advPrev ) ;
			seriesDataNew.prev.dashStyle = 'ShortDashDot';
		}
		returnSeries.push( seriesDataNew.prev ) ;
		return returnSeries;
	}else if( dataset === 'weighted-prevalence') { 

		returnSeries.push( seriesDataNew.wPrev ) ;
		return returnSeries;
	}

	return [];







/*
	const seriesData = [
		{
			name: 'DATASET',
			data: [],
			sampleTotal:[],
			intensityPrevSampleTotal:[],
		}, {
			name: 'Range',
			data: [],
			type: 'arearange',
			lineWidth: 0,
			linkedTo: ':previous',
			//color: Highcharts.getOptions().colors[0],
			fillOpacity: 0.3,
			marker: {
				enabled: false
			},
		}
	];

	switch(dataset) {
		case 'prevalence': {
			seriesData[0].name = 'Prevalence';
			seriesData[0].colorIndex = 2; // = Highcharts.getOptions().colors[0];
			seriesData[1].colorIndex = 2; // = Highcharts.getOptions().colors[0];
			

			Object.keys(compiledData).forEach( (data_year, _idx) =>{
				seriesData[0].sampleTotal.push(compiledData[data_year].sample_size);
				seriesData[0].data.push([parseInt(data_year), compiledData[data_year].prev.mean ]);
				seriesData[1].data.push([parseInt(data_year), compiledData[data_year].prev.minPct, compiledData[data_year].prev.maxPct ]);
			} );
			break;
		//seriesData[0].data.push([parseInt(dataYear), prev]);
		//seriesData[1].data.push([parseInt(dataYear), minPrev, maxPrev]);
		}
		case 'adv-prevalence': {
			seriesData[0].name = 'Advanced Prevalence';
			seriesData[0].colorIndex = 1; // = Highcharts.getOptions().colors[1];
			seriesData[1].colorIndex = 1; // = Highcharts.getOptions().colors[1];
			
			Object.keys(compiledData).forEach( (data_year, _idx) =>{
				seriesData[0].sampleTotal.push(compiledData[data_year].sample_size);
				seriesData[0].data.push([parseInt(data_year), compiledData[data_year].advPrev.mean ]);
				seriesData[1].data.push([parseInt(data_year), compiledData[data_year].advPrev.minPct, compiledData[data_year].advPrev.maxPct ]);
			} );
			break;
		}
		case 'weighted-prevalence': {
			seriesData[0].name = 'Weighted Prevalence';
			seriesData[0].colorIndex = 3; // = Highcharts.getOptions().colors[2];
			seriesData[1].colorIndex = 3; // = Highcharts.getOptions().colors[2];
			
			Object.keys(compiledData).forEach( (data_year, _idx) =>{
				seriesData[0].sampleTotal.push(compiledData[data_year].sample_size);

				seriesData[0].data.push([parseInt(data_year), compiledData[data_year].wPrev.avg ]);
				seriesData[1].data.push([parseInt(data_year), compiledData[data_year].wPrev.minPct, compiledData[data_year].wPrev.maxPct ]);
			} );
			break;
		}
		case 'intensity': {
			seriesData[0].name = 'Intensity';
			seriesData[0].colorIndex = 4; // = Highcharts.getOptions().colors[3];
			seriesData[1].colorIndex = 4; // = Highcharts.getOptions().colors[3];
			
			Object.keys(compiledData).forEach( (data_year, _idx) =>{
				seriesData[0].sampleTotal.push(compiledData[data_year].sample_size);

				seriesData[0].data.push([parseInt(data_year), compiledData[data_year].intensity.avg ]);
				seriesData[1].data.push([parseInt(data_year), compiledData[data_year].intensity.minPct, compiledData[data_year].intensity.maxPct ]);
			} );
			break;
		}
		default: break;
	}


	return seriesData;
	*/
}



const __sortNumber = (a,b) => {
	return a - b;
};
const __quantile = (dataArr, percentile, extraInfo=null) => {


	dataArr.sort(__sortNumber);

	if( extraInfo) {
		console.log(['[DataLogic]', {dataArr, percentile, extraInfo}])
	}

	let index = percentile/100. * (dataArr.length-1);
	let result = null;
	if (Math.floor(index) === index) {
		result = dataArr[index];
	} else {
		let i = Math.floor(index)
		let fraction = index - i;
		result = dataArr[i] + (dataArr[i+1] - dataArr[i]) * fraction;
	}
	return result;
}

/**
 * 
 * @param {array} rawData 
 * @param {object} rawData[]
 * @param {string} rawData[].data_year - year of data (string format)
 * @param {number} rawData[].prev - prevalence in percent #.## from 0 to 1
 * @param {number} rawData[].adv_prev - advanced prevalence in percent #.## from 0 to 1
 * @param {number} rawData[].w_prev - weighted prevalence score from 0 to 5
 * @param {number} rawData[].intensity - intensity float value, but dont really use this, just here for now.
 * @returns 
 */
 const __CompileMonthlyData = (rawData, byYear = 'all') => {
	console.log('[__CompileMonthlyData]',rawData);
	//We can send b


	const monthlyData = {}; //key: month
	
	Object.keys(monthItems).forEach( (month)=>{
		monthlyData[month] = {
			sample_size_arr: [],
			sample_size: 0,
			prev: {
				samples: [],
				pcts: [],
				sum: 0,
				avg:0,
				mean: 0, // sum / sample_size
				min: 0,
				max: 0,
				meanPct: 0,
				minPct: 0,
				maxPct: 0,
				low: null,
				q1: null,
				median: null,
				q3: null,
				high: null,
			},
			lowPrev: {
				samples: [],
				pcts: [],
				sum: 0,
				avg:0,
				mean: 0,
				min: 0,
				max: 0,
				meanPct: 0,
				minPct: 0,
				maxPct: 0,
				low: null,
				q1: null,
				median: null,
				q3: null,
				high: null,
			},
			advPrev: {
				samples: [],
				pcts: [],
				sum: 0,
				avg:0,
				mean: 0,
				min: 0,
				max: 0,
				meanPct: 0,
				minPct: 0,
				maxPct: 0,
				low: null,
				q1: null,
				median: null,
				q3: null,
				high: null,
			},
			wPrev: {
				samples: [],
				pcts: [],
				sum: 0,
				avg:0,
				mean: 0,
				min: 0,
				max: 0,
				meanPct: 0,
				minPct: 0,
				maxPct: 0,

				low: null,
				q1: null,
				median: null,
				q3: null,
				high: null,

			},
			intensity: {
				samples: [],
				pcts: [],
				sum: 0,
				avg:0,
				mean: 0,
				min: 0,
				max: 0,
				meanPct: 0,
				minPct: 0,
				maxPct: 0,

				low: null,
				q1: null,
				median: null,
				q3: null,
				high: null,

			},
		};
	});
	
	
	rawData.forEach( (dataItem) => {
		
		if( byYear !== 'all' ) {
			if( dataItem.data_year !== `${byYear}` ) {
				return;
			}
		}
		monthlyData[dataItem.data_month].sample_size += dataItem.sample_size;

		monthlyData[dataItem.data_month].sample_size_arr.push(dataItem.sample_size);

		monthlyData[dataItem.data_month].prev.pcts.push(dataItem.prev);
		monthlyData[dataItem.data_month].lowPrev.pcts.push(dataItem.low_prev);
		monthlyData[dataItem.data_month].advPrev.pcts.push(dataItem.adv_prev);
		monthlyData[dataItem.data_month].wPrev.pcts.push(dataItem.w_prev);
		

		monthlyData[dataItem.data_month].prev.samples.push( dataItem.sample_size * dataItem.prev);
		monthlyData[dataItem.data_month].lowPrev.samples.push( dataItem.sample_size * dataItem.low_prev);
		monthlyData[dataItem.data_month].advPrev.samples.push( dataItem.sample_size * dataItem.adv_prev);
		monthlyData[dataItem.data_month].wPrev.samples.push( dataItem.sample_size * dataItem.w_prev); 
		monthlyData[dataItem.data_month].intensity.samples.push( dataItem.sample_size * dataItem.prev * dataItem.intensity); 


		//yes i could just do some adding here into the sums to optimize
	});
	



	Object.keys(monthlyData).forEach( (data_month, _idx) =>{
		if( monthlyData[data_month].sample_size === 0 ) {
			return;
		}

		//prev
		monthlyData[data_month].prev.sum = monthlyData[data_month].prev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue});
		monthlyData[data_month].prev.min = Math.min( ...monthlyData[data_month].prev.samples);
		monthlyData[data_month].prev.max = Math.max( ...monthlyData[data_month].prev.samples);
		monthlyData[data_month].prev.mean = (monthlyData[data_month].prev.sum / monthlyData[data_month].sample_size);
		//monthlyData[data_month].prev.mean = jstat.mean( monthlyData[data_month].prev.samples );
		monthlyData[data_month].prev.minPct = Math.min( ...monthlyData[data_month].prev.pcts);
		monthlyData[data_month].prev.maxPct = Math.max( ...monthlyData[data_month].prev.pcts);
		monthlyData[data_month].prev.meanPct = jstat.mean( monthlyData[data_month].prev.pcts );
		
		monthlyData[data_month].prev.low = __quantile( monthlyData[data_month].prev.pcts, 0 );
		monthlyData[data_month].prev.q1 = __quantile( monthlyData[data_month].prev.pcts, 25 );
		monthlyData[data_month].prev.median = __quantile( monthlyData[data_month].prev.pcts, 50 );
		monthlyData[data_month].prev.q3 = __quantile( monthlyData[data_month].prev.pcts, 75 );
		monthlyData[data_month].prev.high = __quantile( monthlyData[data_month].prev.pcts, 100 );


		//low prev
		monthlyData[data_month].lowPrev.sum = monthlyData[data_month].lowPrev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue});
		monthlyData[data_month].lowPrev.min = Math.min( ...monthlyData[data_month].lowPrev.samples);
		monthlyData[data_month].lowPrev.max = Math.max( ...monthlyData[data_month].lowPrev.samples);
		monthlyData[data_month].lowPrev.mean = (monthlyData[data_month].lowPrev.sum / monthlyData[data_month].sample_size);
		//monthlyData[data_month].prev.mean = jstat.mean( monthlyData[data_month].prev.samples );
		monthlyData[data_month].lowPrev.minPct = Math.min( ...monthlyData[data_month].lowPrev.pcts);
		monthlyData[data_month].lowPrev.maxPct = Math.max( ...monthlyData[data_month].lowPrev.pcts);
		monthlyData[data_month].lowPrev.meanPct = jstat.mean( monthlyData[data_month].lowPrev.pcts );

		monthlyData[data_month].lowPrev.low = __quantile( monthlyData[data_month].lowPrev.pcts, 0 );
		monthlyData[data_month].lowPrev.q1 = __quantile( monthlyData[data_month].lowPrev.pcts, 25 );
		monthlyData[data_month].lowPrev.median = __quantile( monthlyData[data_month].lowPrev.pcts, 50 );
		monthlyData[data_month].lowPrev.q3 = __quantile( monthlyData[data_month].lowPrev.pcts, 75, ['lowPrev',data_month,  monthlyData[data_month].lowPrev.pcts] );
		monthlyData[data_month].lowPrev.high = __quantile( monthlyData[data_month].lowPrev.pcts, 100 );
		
		//adv prev
		monthlyData[data_month].advPrev.sum = monthlyData[data_month].advPrev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue}, 0);
		monthlyData[data_month].advPrev.min = Math.min( ...monthlyData[data_month].advPrev.samples);
		monthlyData[data_month].advPrev.max = Math.max( ...monthlyData[data_month].advPrev.samples);
		monthlyData[data_month].advPrev.mean = (monthlyData[data_month].advPrev.sum / monthlyData[data_month].sample_size);
		//monthlyData[data_month].advPrev.mean = jstat.mean( monthlyData[data_month].advPrev.samples );
		monthlyData[data_month].advPrev.minPct = Math.min( ...monthlyData[data_month].advPrev.pcts);
		monthlyData[data_month].advPrev.maxPct = Math.max( ...monthlyData[data_month].advPrev.pcts);
		monthlyData[data_month].advPrev.meanPct = jstat.mean( monthlyData[data_month].advPrev.pcts );

		monthlyData[data_month].advPrev.low = __quantile( monthlyData[data_month].advPrev.pcts, 0 );
		monthlyData[data_month].advPrev.q1 = __quantile( monthlyData[data_month].advPrev.pcts, 25 );
		monthlyData[data_month].advPrev.median = __quantile( monthlyData[data_month].advPrev.pcts, 50 );
		monthlyData[data_month].advPrev.q3 = __quantile( monthlyData[data_month].advPrev.pcts, 75 );
		monthlyData[data_month].advPrev.high = __quantile( monthlyData[data_month].advPrev.pcts, 100 );
		
		//weighted prev
		monthlyData[data_month].wPrev.sum = monthlyData[data_month].wPrev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue}, 0);
		monthlyData[data_month].wPrev.avg = monthlyData[data_month].wPrev.sum / monthlyData[data_month].sample_size;
		monthlyData[data_month].wPrev.min = Math.min( ...monthlyData[data_month].wPrev.pcts);
		monthlyData[data_month].wPrev.max = Math.max( ...monthlyData[data_month].wPrev.pcts);
		monthlyData[data_month].wPrev.mean = jstat.mean( monthlyData[data_month].wPrev.pcts );

		monthlyData[data_month].wPrev.minPct = Math.min( ...monthlyData[data_month].wPrev.pcts);
		monthlyData[data_month].wPrev.maxPct = Math.max( ...monthlyData[data_month].wPrev.pcts);
		monthlyData[data_month].wPrev.meanPct = jstat.mean( monthlyData[data_month].wPrev.pcts );

		monthlyData[data_month].wPrev.low = __quantile( monthlyData[data_month].wPrev.pcts, 0 );
		monthlyData[data_month].wPrev.q1 = __quantile( monthlyData[data_month].wPrev.pcts, 25 );
		monthlyData[data_month].wPrev.median = __quantile( monthlyData[data_month].wPrev.pcts, 50 );
		monthlyData[data_month].wPrev.q3 = __quantile( monthlyData[data_month].wPrev.pcts, 75 );
		monthlyData[data_month].wPrev.high = __quantile( monthlyData[data_month].wPrev.pcts, 100 );
		//intensity
		
		monthlyData[data_month].intensity.sum = monthlyData[data_month].intensity.samples.reduce( (prevValue, currValue) => { return prevValue + currValue}, 0);
		monthlyData[data_month].intensity.avg = monthlyData[data_month].intensity.sum / monthlyData[data_month].sample_size;
		monthlyData[data_month].intensity.min = Math.min( ...monthlyData[data_month].intensity.pcts);
		monthlyData[data_month].intensity.max = Math.max( ...monthlyData[data_month].intensity.pcts);
		monthlyData[data_month].intensity.mean = jstat.mean( monthlyData[data_month].intensity.pcts );

		monthlyData[data_month].intensity.minPct = Math.min( ...monthlyData[data_month].intensity.pcts);
		monthlyData[data_month].intensity.maxPct = Math.max( ...monthlyData[data_month].intensity.pcts);
		monthlyData[data_month].intensity.meanPct = jstat.mean( monthlyData[data_month].intensity.pcts );

		monthlyData[data_month].intensity.low = __quantile( monthlyData[data_month].intensity.pcts, 0 );
		monthlyData[data_month].intensity.q1 = __quantile( monthlyData[data_month].intensity.pcts, 25 );
		monthlyData[data_month].intensity.median = __quantile( monthlyData[data_month].intensity.pcts, 50 );
		monthlyData[data_month].intensity.q3 = __quantile( monthlyData[data_month].intensity.pcts, 75 );
		monthlyData[data_month].intensity.high = __quantile( monthlyData[data_month].intensity.pcts, 100 );
	});



	console.log('Here is the monthly compiled data: ', monthlyData);

	return monthlyData;

}









/**
 * 
 * @param {array} rawData 
 * @param {object} rawData[]
 * @param {string} rawData[].data_year - year of data (string format)
 * @param {number} rawData[].prev - prevalence in percent #.## from 0 to 1
 * @param {number} rawData[].adv_prev - advanced prevalence in percent #.## from 0 to 1
 * @param {number} rawData[].w_prev - weighted prevalence score from 0 to 5
 * @param {number} rawData[].intensity - intensity float value, but dont really use this, just here for now.
 * @returns 
 */
const __CompileYearlyData = (rawData) => {
	console.log('[__CompileYearlyData]',rawData);
	//We can send b
	const yearlyData = {}; //key: year
/*
	// structure of array
	const yearlyData_stock = {
		sample_size_arr: [],
		sample_size: 0,
		prev: {
			samples: [],
			pcts: [],
			sum: 0,
			mean: 0, // sum / sample_size
			min: 0,
			max: 0,
			meanPct: 0,
			minPct: 0,
			maxPct: 0,
		},
		advPrev: {
			samples: [],
			pcts: [],
			sum: 0,
			mean: 0,
			min: 0,
			max: 0,
			meanPct: 0,
			minPct: 0,
			maxPct: 0,
		},
		wPrev: {
			samples: [],
			pcts: [],
			sum: 0,
			mean: 0,
			min: 0,
			max: 0,
			meanPct: 0,
			minPct: 0,
			maxPct: 0,
		},
	};
*/
	
	rawData.forEach( (dataItem) => {
		if( !yearlyData[dataItem.data_year] ) {
			yearlyData[dataItem.data_year] = {
				sample_size_arr: [],
				sample_size: 0,
				prev: {
					samples: [],
					pcts: [],
					sum: 0,
					avg:0,
					mean: 0, // sum / sample_size
					min: 0,
					max: 0,
					meanPct: 0,
					minPct: 0,
					maxPct: 0,
				},
				lowPrev: {
					hasValues:false,
					samples: [],
					pcts: [],
					sum: 0,
					avg:0,
					mean: 0, // sum / sample_size
					min: 0,
					max: 0,
					meanPct: 0,
					minPct: 0,
					maxPct: 0,
				},
				advPrev: {
					hasValues:false,
					samples: [],
					pcts: [],
					sum: 0,
					avg:0,
					mean: 0,
					min: 0,
					max: 0,
					meanPct: 0,
					minPct: 0,
					maxPct: 0,
				},
				wPrev: {
					samples: [],
					pcts: [],
					sum: 0,
					avg:0,
					mean: 0,
					min: 0,
					max: 0,
					meanPct: 0,
					minPct: 0,
					maxPct: 0,
				},
				intensity: {
					samples: [],
					pcts: [],
					sum: 0,
					avg:0,
					mean: 0,
					min: 0,
					max: 0,
					meanPct: 0,
					minPct: 0,
					maxPct: 0,
				},
			};
			//console.log('new yearly data: ', dataItem.data_year, yearlyData[dataItem.data_year]);
		}

		yearlyData[dataItem.data_year].sample_size += dataItem.sample_size;

		//console.log('Current sample size: ', dataItem.data_year, dataItem.sample_size,  yearlyData[dataItem.data_year].sample_size );
		yearlyData[dataItem.data_year].sample_size_arr.push(dataItem.sample_size);

		yearlyData[dataItem.data_year].prev.pcts.push(dataItem.prev);
		yearlyData[dataItem.data_year].lowPrev.pcts.push(dataItem.low_prev);
		yearlyData[dataItem.data_year].advPrev.pcts.push(dataItem.adv_prev);
		yearlyData[dataItem.data_year].wPrev.pcts.push(dataItem.w_prev);
		yearlyData[dataItem.data_year].intensity.pcts.push(dataItem.w_prev);

		yearlyData[dataItem.data_year].prev.samples.push( dataItem.sample_size * dataItem.prev);
		yearlyData[dataItem.data_year].lowPrev.samples.push( dataItem.sample_size * dataItem.low_prev);
		yearlyData[dataItem.data_year].advPrev.samples.push( dataItem.sample_size * dataItem.adv_prev);
		yearlyData[dataItem.data_year].wPrev.samples.push( dataItem.sample_size * dataItem.w_prev); 
		yearlyData[dataItem.data_year].intensity.samples.push( dataItem.sample_size * dataItem.prev * dataItem.intensity); 

		//yes i could just do some adding here into the sums to optimize
		if( dataItem.low_prev !== null ) {
			yearlyData[dataItem.data_year].lowPrev.hasValues = true;
		}
		if( dataItem.adv_prev !== null ) {
			yearlyData[dataItem.data_year].advPrev.hasValues = true;
		}
	});

	//Now that we're all broken out, let's do some compiling by year
	
	Object.keys(yearlyData).forEach( (data_year, _idx) =>{
		if( yearlyData[data_year].sample_size === 0 ) {
			return;
		}

		yearlyData[data_year].prev.sum = yearlyData[data_year].prev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue});
		yearlyData[data_year].prev.min = Math.min( ...yearlyData[data_year].prev.samples);
		yearlyData[data_year].prev.max = Math.max( ...yearlyData[data_year].prev.samples);
		yearlyData[data_year].prev.mean = (yearlyData[data_year].prev.sum / yearlyData[data_year].sample_size);
		//yearlyData[data_year].prev.mean = jstat.mean( yearlyData[data_year].prev.samples );
		yearlyData[data_year].prev.minPct = Math.min( ...yearlyData[data_year].prev.pcts);
		yearlyData[data_year].prev.maxPct = Math.max( ...yearlyData[data_year].prev.pcts);
		yearlyData[data_year].prev.meanPct = jstat.mean( yearlyData[data_year].prev.pcts );
		
		yearlyData[data_year].lowPrev.sum = yearlyData[data_year].lowPrev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue});
		yearlyData[data_year].lowPrev.min = Math.min( ...yearlyData[data_year].lowPrev.samples);
		yearlyData[data_year].lowPrev.max = Math.max( ...yearlyData[data_year].lowPrev.samples);
		yearlyData[data_year].lowPrev.mean = (yearlyData[data_year].lowPrev.sum / yearlyData[data_year].sample_size);
		//yearlyData[data_year].lowPrev.mean = jstat.mean( yearlyData[data_year].advPrev.samples );
		yearlyData[data_year].lowPrev.minPct = Math.min( ...yearlyData[data_year].lowPrev.pcts);
		yearlyData[data_year].lowPrev.maxPct = Math.max( ...yearlyData[data_year].lowPrev.pcts);
		yearlyData[data_year].lowPrev.meanPct = jstat.mean( yearlyData[data_year].lowPrev.pcts );

		yearlyData[data_year].advPrev.sum = yearlyData[data_year].advPrev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue});
		yearlyData[data_year].advPrev.min = Math.min( ...yearlyData[data_year].advPrev.samples);
		yearlyData[data_year].advPrev.max = Math.max( ...yearlyData[data_year].advPrev.samples);
		yearlyData[data_year].advPrev.mean = (yearlyData[data_year].advPrev.sum / yearlyData[data_year].sample_size);
		//yearlyData[data_year].advPrev.mean = jstat.mean( yearlyData[data_year].advPrev.samples );
		yearlyData[data_year].advPrev.minPct = Math.min( ...yearlyData[data_year].advPrev.pcts);
		yearlyData[data_year].advPrev.maxPct = Math.max( ...yearlyData[data_year].advPrev.pcts);
		yearlyData[data_year].advPrev.meanPct = jstat.mean( yearlyData[data_year].advPrev.pcts );
		
		yearlyData[data_year].wPrev.sum = yearlyData[data_year].wPrev.samples.reduce( (prevValue, currValue) => { return prevValue + currValue});
		yearlyData[data_year].wPrev.min = Math.min( ...yearlyData[data_year].wPrev.samples);
		yearlyData[data_year].wPrev.max = Math.max( ...yearlyData[data_year].wPrev.samples);
		//yearlyData[data_year].wPrev.mean = (yearlyData[data_year].wPrev.sum / yearlyData[data_year].sample_size);
		yearlyData[data_year].wPrev.avg =  yearlyData[data_year].wPrev.sum / yearlyData[data_year].sample_size;
		yearlyData[data_year].wPrev.mean = jstat.mean( yearlyData[data_year].wPrev.samples );
		yearlyData[data_year].wPrev.minPct = Math.min( ...yearlyData[data_year].wPrev.pcts);
		yearlyData[data_year].wPrev.maxPct = Math.max( ...yearlyData[data_year].wPrev.pcts);
		yearlyData[data_year].wPrev.meanPct = jstat.mean( yearlyData[data_year].wPrev.pcts );

		
		yearlyData[data_year].intensity.sum = yearlyData[data_year].intensity.samples.reduce( (prevValue, currValue) => { return prevValue + currValue});
		yearlyData[data_year].intensity.avg =  yearlyData[data_year].intensity.sum / yearlyData[data_year].sample_size;

		return true;
	});

	return yearlyData;

}

















/*
const _Highcharts_LineChartByYear = (data) => {
	//console.log('Highcharts: Create Line Chart By Year', data);


	const seriesData = [
		{
			name: 'Prevalence',
			data: [],
			sampleTotal:[],
		}, {
			name: 'Range',
			data: [],
			type: 'arearange',
			lineWidth: 0,
			linkedTo: ':previous',
			//color: Highcharts.getOptions().colors[0],
			fillOpacity: 0.3,
			marker: {
				enabled: false
			}
		}
	];

	const rawYearData={};

	data.forEach((rawData) => {
		if( !rawYearData[rawData.data_year] ) {
			rawYearData[rawData.data_year] = [];
		}
		rawYearData[rawData.data_year].push({
			samples: rawData.sample_size,
			prev: rawData.prev
		});
	});

	//console.log('Raw Year Data for Prevalence Data: ', rawYearData);


	Object.keys(rawYearData)
	.forEach( (dataYear) => {
		let minPrev = 6;
		let maxPrev = -1;

		let prev = 0.0;
		let prevSamples = 0;
		let samples = 0;

		rawYearData[dataYear].forEach((prevItem) => {
			samples+=parseInt(prevItem.samples);
			prevSamples+=parseInt( prevItem.samples * prevItem.prev );

			if( maxPrev < parseFloat(prevItem.prev) ) {
				maxPrev = parseFloat(prevItem.prev);
			}
			if( parseFloat(prevItem.prev) < minPrev) {
				minPrev = parseFloat(prevItem.prev);
			}
		});

		if( samples > 0 ) {
			prev = prevSamples/samples;
		}

		seriesData[0].data.push([parseInt(dataYear), prev]);
		seriesData[1].data.push([parseInt(dataYear), minPrev, maxPrev]);


	});

	

	return seriesData;

}
*/